/**
 * @format
 */

import { SignInResponse, UpdatePasswordSession } from '../types/auth.types';

export const handleTokenStorage = (signInResponse: SignInResponse): void => {
  localStorage.setItem('accessToken', signInResponse.accessToken);
  localStorage.setItem('idToken', signInResponse.idToken);
  localStorage.setItem('userRole', signInResponse.role);
  
  if (signInResponse.officeId) {
    localStorage.setItem('officeId', signInResponse.officeId);
  }
};

export const handlePasswordChangeSession = (
  signInResponse: SignInResponse,
  username: string
): void => {
  sessionStorage.setItem(
    'updatePasswordSession',
    JSON.stringify({
      session: signInResponse.session,
      username,
    } as UpdatePasswordSession)
  );
};

export const getNavigationPath = (userRole: string): string => {
  const roleLower = userRole.toLowerCase();
  
  switch (roleLower) {
    case 'admin':
      return '/dashboard';
    case 'agent':
      return '/dashboard';
    case 'custo':
      return '/forms';
    case 'root_custo':
      return '/forms';
    default:
      return '/dashboard';
  }
};

export const clearAuthStorage = (): void => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('idToken');
  localStorage.removeItem('userRole');
  localStorage.removeItem('officeId');
  sessionStorage.removeItem('updatePasswordSession');
};
